module.exports = __webpack_public_path__ + "static/media/accuracy.daaa929d.svg";